<script>
import { createEditDeltaComponent } from '@/components/edit-delta-factory';
import commonMixin from '@/plans/ZOOM_WHITEBOARD/mixin';
import { planTypes } from '@/common/constants';

export default createEditDeltaComponent({
  name: 'WhiteboardEditDelta',
  planType: planTypes.ZOOM_WHITEBOARD,
  mixin: commonMixin,
});
</script>

<style lang="scss">
.opc-zwb {
  &__preview-payment {
    margin-top: 24px;
  }
}
</style>
